module.exports = __webpack_public_path__ + "static/media/3p.5995b07d.png";